<template>
  <div class="mt-8 border border-vice-light-grey overflow-hidden rounded-lg">
    <!-- Header -->
    <div class="py-5 px-4 sm:px-6 border-b border-vice-light-grey bg-gray-50">
      <div class="flex flex-col md:flex-row justify-between gap-3">
        <jet-section-title>
          <template #title>
            <slot name="title"></slot>
          </template>
        </jet-section-title>
      </div>
    </div>

    <!-- Body -->
    <div class="px-4 py-4 bg-white sm:px-6 flex-grow">
      <div class="flex-shrink-0 group">
        <p class="mt-1 text-md text-vice-teal-900">
          <slot name="description"></slot>
        </p>
        <form @submit.prevent="$emit('submitted')">
          <div class="flex-1 flex-wrap gap-6">
            <slot name="content"></slot>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import JetSectionTitle from './SectionTitle.vue';

export default {
  components: {
    JetSectionTitle,
  },
};
</script>
